import { render, staticRenderFns } from "./CustomerLog.vue?vue&type=template&id=2e6d4f66&"
import script from "./CustomerLog.vue?vue&type=script&lang=js&"
export * from "./CustomerLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports